export default "on Page {\n  id\n  name\n  slug\n  content\n  status\n  cover {\n    id\n    url\n  }\n  archivedAt\n  url\n}";